// Reads the configuration injected by public/config.js, which is served as a
// plain script ahead of the bundle. Nothing here is inlined at build time, so a
// single build artifact can be deployed to any environment.

const injected = (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) || {};

// envsubst leaves an empty string for variables that were never set, and an
// untouched "${NAME}" if the template was served without substitution. Both mean
// the value is missing — never fall back to a hardcoded environment.
const read = (key) => {
  const raw = injected[key];
  if (typeof raw !== 'string' || raw === '' || raw.startsWith('${')) {
    return undefined;
  }
  return raw;
};

const runtimeConfig = {
  apiUrl: read('apiUrl'),
  appEnv: read('appEnv') || 'unknown',
};

if (!runtimeConfig.apiUrl) {
  // eslint-disable-next-line no-console
  console.error(
    'Runtime config: apiUrl is missing. Check that config.js is being served and that API_URL is set on the container.'
  );
}

// Callers must go through this rather than reading apiUrl directly. Concatenating
// an undefined base produces "undefined/monitors", which the browser happily
// resolves against the current page — a same-origin request to a nonsense path
// that looks like a routing bug rather than a missing setting.
const requireApiUrl = () => {
  if (!runtimeConfig.apiUrl) {
    throw new Error(
      'API is not configured: API_URL is unset on the container, so /config.js was served with an empty apiUrl.'
    );
  }
  return runtimeConfig.apiUrl;
};

export { runtimeConfig, requireApiUrl };
